const ABOUT_IMG =
  "https://public.readdy.ai/ai/img_res/a56a140ea399a79f193bdd2b591b757e.jpg";

const STATS = [
  { value: "iOS", label: "Exclusive Platform Focus" },
  { value: "100%", label: "In-House Development" },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-32 bg-gray-50">
      <div className="max-w-screen-xl mx-auto px-8">
        {/* Section Label */}
        <div className="flex justify-center mb-4">
          <span className="text-xs uppercase tracking-widest font-semibold text-teal-600 bg-teal-50 px-4 py-1.5 rounded-full">
            Who We Are
          </span>
        </div>

        <h2 className="text-center text-4xl md:text-5xl font-bold text-gray-900 mb-16">
          Expert Team Building <br className="hidden md:block" />
          Modern iOS Solutions
        </h2>

        {/* Two columns */}
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Text */}
          <div className="flex flex-col gap-6">
            <p className="text-gray-600 text-lg leading-relaxed">
              ZAREV OOD is a dedicated team of specialists focused entirely on
              the iOS platform. We combine deep technical expertise with a
              passion for clean, purposeful design to deliver applications that
              truly make a difference in people's daily lives.
            </p>
            <p className="text-gray-600 text-lg leading-relaxed">
              Our approach is simple: understand the user's real needs and build
              solutions that are fast, reliable, and intuitive. Every line of
              code we write reflects our commitment to quality and security.
            </p>
            <p className="text-gray-600 text-lg leading-relaxed">
              Based in Bulgaria, we operate globally, serving users who demand
              the very best from their iOS devices. Our products are built from
              the ground up for Apple's ecosystem — no compromises, no shortcuts.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mt-4 pt-8 border-t border-gray-200">
              {STATS.map((stat) => (
                <div key={stat.label} className="flex flex-col gap-1">
                  <span className="text-3xl font-extrabold text-teal-600">
                    {stat.value}
                  </span>
                  <span className="text-sm text-gray-500 leading-snug">
                    {stat.label}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="w-full h-96 rounded-2xl overflow-hidden">
            <img
              src={ABOUT_IMG}
              alt="ZAREV OOD iOS app development"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
